module.exports = __webpack_public_path__ + "static/media/print-footer-bg.5ea38d26.webp";